import axios, { AxiosResponse } from 'axios';
import { ArgumentosRecaudacionDTO, DetalleArchivoRecaudadoDto } from '../models/registrarRecaudacionMasiva';
import axiosInstance from '../../../../interceptors/axiosInstance';
import { ListResponseDto } from "../../../../dtos/ListResponseDto";



export async function validarArchivo(argumentos: ArgumentosRecaudacionDTO) {

  const formData = new FormData();
  formData.append("rutRecaudador", argumentos.rutRecaudador);
  formData.append("fechaRecaudacion", argumentos.fechaRecaudacion.toISOString());
  formData.append("file", argumentos.archivo); 
  formData.append("nombreArchivo", argumentos.nombreArchivo ?? '');
  formData.append("login", argumentos.Login ?? '');
  
  const response = await axiosInstance.post(`siscred-api-recaudacion/v1/registrarrecaudacion/recaudar-archivo`, formData);

  return response;
}

export async function getDetalle(rutRecaudador: string) { 
    const response: AxiosResponse<ListResponseDto<DetalleArchivoRecaudadoDto>> = await axiosInstance.get('siscred-api-recaudacion/v1/registrarrecaudacion/obtener-detale', {
        params: {
            rutRecaudador: rutRecaudador
        },
    });
    return response;
}



